// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eafdB","field":"styles_field__1C4_k","fieldCol":"styles_fieldCol__1Xoff","diffCol":"styles_diffCol__2IPQC","diff":"styles_diff__2oWyf"};